export const comments_5588479 = {"data":{"data":[],"links":{}}}